<script setup lang="ts">
const localePath = useLocalePath();

const highIntentLinks = [
  { title: "Notes", to: "/11th/english/notes/", description: "Chapter-wise notes aur explanations." },
  { title: "Downloads", to: "/11th/english/downloads/", description: "Textbook, notes, grammar PDF aur model paper." },
  { title: "MCQs", to: "/11th/english/mcqs/", description: "Important MCQs aur objective practice." },
  { title: "Short Questions", to: "/11th/english/short-questions/", description: "Chapter-wise short questions ki tayari." },
  { title: "Long Questions", to: "/11th/english/long-questions/", description: "Important long questions aur un ki tayari." },
  { title: "Grammar", to: "/11th/english/grammar/", description: "Grammar aur composition ki tamam important cheezen." },
  { title: "Solved Exercise", to: "/11th/english/solved-exercise/", description: "Exercise questions with answers." },
];

const sections = [
  { title: "Prose", to: "/11th/english/prose/", description: "Units 1, 2, 4, 5, 7, 8, 10, 12 ke notes, questions aur analysis." },
  { title: "Poems", to: "/11th/english/poems/", description: "Units 3, 6, 9, 11, 13 ke stanza, explanation aur literary prep." },
  { title: "Play", to: "/11th/english/play/", description: "Unit 14 play ke scenes, themes aur long-question support." },
  { title: "Grammar & Composition", to: "/11th/english/grammar/", description: "Pair of words, punctuation, letters, applications aur stories." },
];

const grammarQuickLinks = [
  { label: "Stories", to: localePath("/11th/english/grammar/story-writing/"), icon: "heroicons:arrow-up-right" },
  { label: "Letters", to: localePath("/11th/english/grammar/letters/"), icon: "heroicons:arrow-up-right" },
  { label: "Applications", to: localePath("/11th/english/grammar/applications/"), icon: "heroicons:arrow-up-right" },
  { label: "Pair of Words", to: localePath("/11th/english/grammar/pair-of-words/"), icon: "heroicons:arrow-up-right" },
  { label: "Translation", to: localePath("/11th/english/grammar/translation/"), icon: "heroicons:arrow-up-right" },
  { label: "Essay", to: localePath("/11th/english/grammar/essay/"), icon: "heroicons:arrow-up-right" },
  { label: "Grammar with MCQs", to: localePath("/11th/english/grammar-with-mcqs/"), icon: "heroicons:arrow-up-right" },
  { label: "MCQs", to: localePath("/11th/english/mcqs/"), icon: "heroicons:arrow-up-right" },
];

const knowledgeGraphUnits = [
  { unit: "Unit 1", title: "Khatam-un-Nabiyeen Hazrat Muhammad", type: "Prose", to: "/11th/english/prose/khatam-un-nabiyeen-hazrat-muhammad/", focus: "character, mission, justice, Farewell Sermon" },
  { unit: "Unit 2", title: "Responsibility of the Youth in Nation-Building", type: "Prose", to: "/11th/english/prose/responsibility-of-the-youth-in-nation-building/", focus: "discipline, youth role, nation-building" },
  { unit: "Unit 3", title: "A Bird Came Down the Walk", type: "Poem", to: "/11th/english/poems/a-bird-came-down-the-walk/", focus: "imagery, simile, observation of nature" },
  { unit: "Unit 4", title: "Team Moon", type: "Prose", to: "/11th/english/prose/team-moon/", focus: "teamwork, hidden contributors, Mission Control" },
  { unit: "Unit 5", title: "Impact of Global Warming on Pakistan", type: "Prose", to: "/11th/english/prose/impact-of-global-warming-on-pakistan/", focus: "climate effects, causes, response" },
  { unit: "Unit 6", title: "The Echoing Green", type: "Poem", to: "/11th/english/poems/the-echoing-green/", focus: "joy, childhood, symbolic contrast" },
  { unit: "Unit 7", title: "What You Do is What You Are", type: "Prose", to: "/11th/english/prose/what-you-do-is-what-you-are/", focus: "language, class, unpaid work" },
  { unit: "Unit 8", title: "Clean Water", type: "Prose", to: "/11th/english/prose/clean-water/", focus: "health, water access, public responsibility" },
  { unit: "Unit 9", title: "Freedom", type: "Poem", to: "/11th/english/poems/freedom/", focus: "liberty, dignity, tone, message" },
  { unit: "Unit 10", title: "The Punishment of Shahpesh, the Persian, on Khipil, the Builder", type: "Prose", to: "/11th/english/prose/the-punishment-of-shahpesh-the-persian-on-khipil-the-builder/", focus: "justice, pride, moral consequence" },
  { unit: "Unit 11", title: "Those Winter Sundays", type: "Poem", to: "/11th/english/poems/those-winter-sundays/", focus: "silent love, regret, sacrifice" },
  { unit: "Unit 12", title: "The Impact of AI on Society, Human Relationships, and Ethics", type: "Prose", to: "/11th/english/prose/the-impact-of-ai-on-society-human-relationships-and-ethics/", focus: "AI benefits, risks, ethics, relationships" },
  { unit: "Unit 13", title: "Ruba'iyat", type: "Poem", to: "/11th/english/poems/rubaiyat/", focus: "faith, unity, spiritual reflection" },
  { unit: "Unit 14", title: "The End of the Beginning", type: "Play", to: "/11th/english/play/the-end-of-the-beginning/", focus: "humor, role reversal, domestic conflict" },
];

const faqs = [
  {
    question: "Can I open chapters directly from this page?",
    answer: "Haan. Har chapter card par click karke aap seedha us chapter ke page par ja sakte hain.",
  },
  {
    question: "How should I use this page for exam prep?",
    answer: "Pehle apni zarurat choose karein, jaise notes, MCQs, short questions ya grammar. Phir neeche se apna chapter khol kar tayari shuru karein.",
  },
  {
    question: "What will I find on the chapter pages?",
    answer: "Aksar chapter pages par notes, important points, questions, answers aur MCQs milte hain.",
  },
];

usePageSeo({
  title: "11th Class English Notes | MCQs, Short Questions, Long Questions, Grammar",
  description: "11th class English ke liye notes, MCQs, short questions, long questions, grammar, solved exercise aur chapter-wise knowledge graph ka main hub.",
  keywords: "11th class english notes, class 11 english notes, 1st year english notes, english mcqs, short questions, long questions, grammar",
  schemaType: "CollectionPage",
  schemaProperties: {
    mainEntity: {
      "@type": "ItemList",
      itemListElement: knowledgeGraphUnits.map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: `${item.unit}: ${item.title}`,
        url: `https://ustaad.today${item.to}`,
      })),
    },
  },
  faqs,
  breadcrumbs: [
    { name: "Home", item: "/" },
    { name: "11th English", item: "/11th/english/" },
  ],
});
</script>

<template>
  <PageContainer>
    <EnglishHero
      headline="11th Class English"
      title="11th Class English"
      description="Yeh 1st year English ka main page hai. Yahan se aap notes, MCQs, short questions, long questions, grammar aur chapter-wise pages asani se khol sakte hain."
      :links="[
        { label: 'Notes', to: localePath('/11th/english/notes/') },
        { label: 'Grammar', to: localePath('/11th/english/grammar/') }
      ]"
    />

    <EnglishSection
      title="Important Pages"
      description="Apni zarurat ke mutabiq section choose karein."
    >
      <EnglishGrid>
        <EnglishCard
          v-for="item in highIntentLinks"
          :key="item.to"
          :to="localePath(item.to)"
          :title="item.title"
          :description="item.description"
        />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection
      title="Main Sections"
      description="Subject ko asan samajhne ke liye prose, poems, play aur grammar me divide kiya gaya hai."
    >
      <EnglishGrid>
        <EnglishCard
          v-for="item in sections"
          :key="item.to"
          :to="localePath(item.to)"
          :title="item.title"
          :description="item.description"
        />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection
      title="Chapter List"
      description="Neeche se apna chapter kholain."
    >
      <EnglishGrid>
        <EnglishCard
          v-for="unit in knowledgeGraphUnits"
          :key="unit.to"
          :to="localePath(unit.to)"
          :title="`${unit.unit}: ${unit.title}`"
          :description="`Type: ${unit.type}. Focus: ${unit.focus}.`"
        />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection
      title="Grammar Links"
      description="Grammar ke important topics yahan se seedhe khol sakte hain."
    >
      <EnglishLinkList title="Grammar Topics" :links="grammarQuickLinks" />
    </EnglishSection>

    <EnglishSection
      title="FAQs"
      description="11th class English ke bare me aam sawalon ke jawab."
    >
      <EnglishGrid>
        <EnglishCard
          v-for="item in faqs"
          :key="item.question"
          :title="item.question"
          :description="item.answer"
        />
      </EnglishGrid>
    </EnglishSection>
  </PageContainer>
</template>
